module.exports = __webpack_public_path__ + "static/movistar-4035be5eeb999ddd0e8ef59b3649c6d2.jpg";